import axios from 'axios';

// 2FA calls deliberately use a bare axios call rather than the shared `api`
// instance: `api` has a global "401 -> wipe token + redirect to /login"
// interceptor, and a wrong 2FA code legitimately returns 401. We don't want a
// mistyped code to log the user out, so errors surface to the caller instead.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface TwoFAStatus {
  enabled: boolean;
  recovery_codes_remaining: number;
}
export interface TwoFASetup {
  secret: string;
  otpauth_uri: string;
}

export const twoFactor = {
  status: async (): Promise<TwoFAStatus> =>
    (await axios.get(`${API_BASE_URL}/api/2fa/status`, { headers: authHeaders() })).data,

  setup: async (): Promise<TwoFASetup> =>
    (await axios.post(`${API_BASE_URL}/api/2fa/setup`, {}, { headers: authHeaders() })).data,

  enable: async (code: string): Promise<{ enabled: boolean; recovery_codes: string[] }> =>
    (await axios.post(`${API_BASE_URL}/api/2fa/enable`, { code }, { headers: authHeaders() })).data,

  disable: async (code: string): Promise<{ enabled: boolean }> =>
    (await axios.post(`${API_BASE_URL}/api/2fa/disable`, { code }, { headers: authHeaders() })).data,

  regenerateRecoveryCodes: async (code: string): Promise<{ recovery_codes: string[] }> =>
    (await axios.post(`${API_BASE_URL}/api/2fa/recovery-codes`, { code }, { headers: authHeaders() })).data,

  // Second step of a 2FA login — no token yet; the mfa_token carries identity.
  verifyLogin: async (
    mfaToken: string,
    code: string,
  ): Promise<{ access_token: string; user_id: string; email: string }> =>
    (await axios.post(`${API_BASE_URL}/api/auth/login/verify-2fa`, { mfa_token: mfaToken, code })).data,
};
